import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer } from '@mui/material';
import MenuIndentDecrease from "../assets/images/ri-indent-decrease.png";


//import images
// import logoSm from "../assets/images/logo-sm.png";
// import logoDark from "../assets/images/logo-dark.png";
// import logoLight from "../assets/images/logo-light.png";

// //import Components
// import SearchOption from '../Components/Common/SearchOption';
// import WebAppsDropdown from '../Components/Common/WebAppsDropdown';
// import MyCartDropdown from '../Components/Common/MyCartDropdown';
// import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
// import LightDark from '../Components/Common/LightDark';

const Header = ({ onMenuIconClick }) => {
    const [search, setSearch] = useState(false);
    const [update, setUpdate] = useState(0)
    const [openDrawer, setOpenDrawer] = useState(false);
    const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(false);

    const toogleSearch = () => {
        setSearch(!search);
    };

    const toggleHeaderCollapse = () => {
        setIsHeaderCollapsed(!isHeaderCollapsed);
    };


    const handleDrawerOpen = () => {
        setOpenDrawer(true);
    };

    const handleDrawerClose = () => {
        setOpenDrawer(false);
    };


    const refreshNotification = () => {
        setUpdate(update + 1)
    }

    return (
        <React.Fragment>
            <header id="page-topbar" style={{ left: isHeaderCollapsed ? '60px' : '280px'}}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex align-items-center ps-2">
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick = {() => {
                                    onMenuIconClick();
                                    toggleHeaderCollapse();
                                }}
                                edge="start"
                            >
                                <img src={MenuIndentDecrease} alt={MenuIndentDecrease} />
                                {/* <MenuIcon /> */}
                            </IconButton>
                        </div>
                        <div className="d-flex align-items-center">
                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* LanguageDropdown */}
                            <LanguageDropdown />

                            {/* WebAppsDropdown */}
                            {/* <WebAppsDropdown /> */}

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            {/* <FullScreenDropdown /> */}

                            {/* Dark/Light Mode set */}
                            {/* <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            /> */}

                            {/* NotificationDropdown */}
                            <NotificationDropdown key={update} refreshNotification={refreshNotification} />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
                {/* <Drawer
                    anchor="left"
                    open={openDrawer}
                    onClose={handleDrawerClose}
                    variant="temporary"
                    sx={{
                        '& .MuiDrawer-paper': { width: 240, boxSizing: 'border-box' },
                    }}
                > */}
                    {/* <CaspSidebar open={openDrawer} /> */}
                {/* </Drawer> */}
            </header>
        </React.Fragment>
    );
};

export default Header;